import type { RacemapStarter } from '@racemap/utilities/types/events';
import type { ObjectId } from 'bson';
import useSWR, { type SWRConfiguration } from 'swr';
import { apiClient } from '.';

/**
 * Returns the starter of an given id
 *
 * @returns {starter: RacemapStarter | undefined, isLoading: boolean, error: Error, mutate: () => void}
 */
export function useStarter(
  starterId: string | ObjectId | undefined | null,
  options?: SWRConfiguration,
): {
  starter: RacemapStarter | null | undefined;
  isLoading: boolean;
  error: Error;
  mutate: () => void;
} {
  const { data, isLoading, error, mutate } = useSWR(
    starterId ? ['GET', 'STARTER', starterId.toString()] : null,
    async ([, , starterId]) => {
      const starter = await apiClient.getStarter(starterId);
      return starter;
    },
    options,
  );

  return { starter: data, isLoading, error, mutate };
}
